import React, { useEffect, useState } from 'react';
import { adminAPI, extendedAdminAPI } from '../../utils/api';
import api from '../../utils/api';

const AdminStudents = () => {
  const [students, setStudents] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 20;
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState({ department: '', university: '', name: '', email: '', city: '', grade: '', gpa_min: '', skill: '', certificate: '', profile_complete: '', has_cv: '', work_type: '', internship_type: '', internship_period: '', award: '', project: '', focus_area: '', llm_level: '' });
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [details, setDetails] = useState({});
  const [assignFor, setAssignFor] = useState(null);
  const [assignPositions, setAssignPositions] = useState([]);
  const [assignPositionId, setAssignPositionId] = useState('');
  const [assignMessage, setAssignMessage] = useState('');
  const [assignSending, setAssignSending] = useState(false);
  const [assignToast, setAssignToast] = useState('');
  const [detailLoading, setDetailLoading] = useState(null);

  const load = (params = {}, pg = 1) => {
    setLoading(true);
    setExpanded(null);
    adminAPI.getStudents({ ...params, page: pg, limit: PAGE_SIZE })
      .then(r => {
        const data = r.data;
        if (data && data.students) {
          setStudents(data.students);
          setTotal(data.total || 0);
        } else {
          setStudents(Array.isArray(data) ? data : []);
          setTotal(0);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const [searchParams, setSearchParams] = useState({});

  useEffect(() => {
    // Analitik kartından deep-link: /admin/students?llm_level=junior
    const usp = new URLSearchParams(window.location.search);
    const lvl = usp.get('llm_level');
    if (lvl && ['junior', 'mid', 'senior'].includes(lvl)) {
      setSearch(s => ({ ...s, llm_level: lvl }));
      setSearchParams({ llm_level: lvl });
      setShowAdvanced(true);
      load({ llm_level: lvl }, 1);
    } else {
      load();
    }
  }, []);

  const [sort, setSort] = useState({ field: 'created_at', dir: 'desc' });

  const handleSearch = (e) => {
    e.preventDefault();
    const params = {};
    Object.entries(search).forEach(([k,v]) => { if (v !== '' && v !== undefined) params[k] = v; });
    setSearchParams(params);
    setPage(1);
    load({ ...params, sort_by: sort.field, sort_dir: sort.dir }, 1);
  };
  const handlePage = (pg) => {
    setPage(pg);
    load({ ...searchParams, sort_by: sort.field, sort_dir: sort.dir }, pg);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleSort = (field) => {
    const newDir = sort.field === field && sort.dir === 'asc' ? 'desc' : 'asc';
    const newSort = { field, dir: newDir };
    setSort(newSort);
    setPage(1);
    load({ ...searchParams, sort_by: field, sort_dir: newDir }, 1);
  };
  const SortTh = ({ field, children }) => {
    const active = sort.field === field;
    return (
      <th onClick={() => handleSort(field)}
        style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: active ? '#2563eb' : '#6b7280', whiteSpace: 'nowrap', cursor: 'pointer', userSelect: 'none' }}>
        {children} <span style={{ fontSize: 10, opacity: active ? 1 : 0.35 }}>{active ? (sort.dir === 'asc' ? '↑' : '↓') : '⇅'}</span>
      </th>
    );
  };

  const totalPages = Math.ceil(total / PAGE_SIZE);
  const Pagination = () => {
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0', marginTop: 8, borderTop: '1px solid #e5e7eb' }}>
        <span style={{ fontSize: 13, color: '#6b7280' }}>
          Toplam <strong>{total}</strong> öğrenci · Sayfa <strong>{page}</strong> / <strong>{totalPages}</strong>
        </span>
        <div style={{ display: 'flex', gap: 4 }}>
          <button onClick={() => handlePage(page - 1)} disabled={page === 1}
            style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: page === 1 ? '#f9fafb' : '#fff', color: page === 1 ? '#d1d5db' : '#374151', cursor: page === 1 ? 'not-allowed' : 'pointer', fontSize: 13 }}>
            ‹ Önceki
          </button>
          {pages.map((pg, i) => (
            pg === '...'
              ? <span key={i} style={{ padding: '5px 4px', color: '#9ca3af', fontSize: 13 }}>…</span>
              : <button key={pg} onClick={() => handlePage(pg)}
                  style={{ padding: '5px 11px', borderRadius: 6, border: '1px solid #d1d5db', background: pg === page ? '#2563eb' : '#fff', color: pg === page ? '#fff' : '#374151', cursor: 'pointer', fontSize: 13, fontWeight: pg === page ? 600 : 400 }}>
                  {pg}
                </button>
          ))}
          <button onClick={() => handlePage(page + 1)} disabled={page === totalPages}
            style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: page === totalPages ? '#f9fafb' : '#fff', color: page === totalPages ? '#d1d5db' : '#374151', cursor: page === totalPages ? 'not-allowed' : 'pointer', fontSize: 13 }}>
            Sonraki ›
          </button>
        </div>
      </div>
    );
  };

  const toggleRow = async (student) => {
    if (expanded === student.id) {
      setExpanded(null);
      return;
    }
    setExpanded(student.id);
    if (!details[student.id]) {
      setDetailLoading(student.id);
      try {
        const r = await api.get(`/admin/students/${student.id}`);
        setDetails(prev => ({ ...prev, [student.id]: r.data }));
      } catch {
        setDetails(prev => ({ ...prev, [student.id]: student }));
      } finally {
        setDetailLoading(null);
      }
    }
  };

  const handleExport = async () => {
    try {
      const r = await adminAPI.exportStudents();
      const url = URL.createObjectURL(new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const a = document.createElement('a'); a.href = url; a.download = 'ogrenciler.xlsx'; a.click();
      URL.revokeObjectURL(url);
    } catch { alert('Export başarısız'); }
  };


  useEffect(() => {
    extendedAdminAPI.getPositions().then(r => setAssignPositions(r.data || [])).catch(() => {});
  }, []);

  const Tag = ({ label, color = '#1d4ed8', bg = '#eff6ff' }) => (
    <span style={{ background: bg, color, fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 500 }}>{label}</span>
  );

  const ScoreBar = ({ label, value, max, color }) => (
    <div style={{ marginBottom: 6 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginBottom: 2 }}>
        <span style={{ color: '#6b7280' }}>{label}</span>
        <span style={{ fontWeight: 600, color }}>{value}/{max}</span>
      </div>
      <div style={{ height: 5, background: '#e5e7eb', borderRadius: 3 }}>
        <div style={{ height: '100%', width: `${(value/max)*100}%`, background: color, borderRadius: 3, transition: 'width 0.3s' }} />
      </div>
    </div>
  );

  const [runningCV, setRunningCV] = useState(false);
  const [cvToast, setCvToast] = useState('');
  const handleRunCV = async () => {
    setRunningCV(true);
    try {
      await api.post('/admin/run-cv-analysis');
      setCvToast('CV analizi başlatıldı, birkaç dakika sürer.');
    } catch { setCvToast('Başlatılamadı.'); }
    setTimeout(() => setCvToast(''), 5000);
    setRunningCV(false);
  };

  const [runningLLM, setRunningLLM] = useState(false);
  const handleRunLLM = async () => {
    setRunningLLM(true);
    try {
      await api.post('/admin/run-llm-analysis');
      setCvToast('✦ AI analizi başlatıldı, arka planda çalışıyor.');
    } catch { setCvToast('AI analizi başlatılamadı.'); }
    setTimeout(() => setCvToast(''), 5000);
    setRunningLLM(false);
  };

  const handleDownloadPDF = async (student) => {
    try {
      const token = localStorage.getItem('token');
      const baseURL = api.defaults.baseURL || '/api';
      const res = await fetch(`${baseURL}/admin/students/${student.id}/pdf`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('PDF alınamadı');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `rapor-${student.first_name}-${student.last_name}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch { alert('PDF indirilemedi.'); }
  };

  const handleViewCV = async (cvUrl) => {
    try {
      const token = localStorage.getItem('token');
      const apiBase = (api.defaults.baseURL || '/api').replace('/api', '');
      const res = await fetch(`${apiBase}${cvUrl}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('CV alınamadı');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch { alert('CV açılamadı.'); }
  };

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 8, paddingBottom: 5, borderBottom: '1px solid #e5e7eb' }}>{title}</div>
      {children}
    </div>
  );

  const DetailPanel = ({ s }) => {
    const profileTotal = (+(s.skills_score||0)) + (+(s.cert_score||0)) + (+(s.academic_score||0)) + (+(s.ctf_score||0)) + (+(s.experience_score||0));
    return (
    <div style={{ background: '#f8fafc', borderTop: '1px solid #e5e7eb' }}>
      {/* Skor Özeti */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, padding: '16px 24px 0' }}>
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 12 }}>📊 Profil Puanı — <span style={{ color: profileTotal >= 70 ? '#059669' : profileTotal >= 40 ? '#d97706' : '#6b7280' }}>{profileTotal}/100</span></div>
          <ScoreBar label="Teknik Beceriler" value={+(s.skills_score||0)} max={25} color="#2563eb" />
          <ScoreBar label="Sertifikalar" value={+(s.cert_score||0)} max={25} color="#7c3aed" />
          <ScoreBar label="Akademik" value={+(s.academic_score||0)} max={20} color="#0891b2" />
          <ScoreBar label="CTF & Platform" value={+(s.ctf_score||0)} max={15} color="#d97706" />
          <ScoreBar label="Proje & Deneyim" value={+(s.experience_score||0)} max={15} color="#059669" />
        </div>
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 12 }}>🤖 CV Anahtar Kelime Puanı — <span style={{ color: '#7c3aed' }}>{s.cv_keyword_score != null ? `${s.cv_keyword_score}/100` : 'Analiz edilmedi'}</span></div>
          {s.cv_keywords_found?.length > 0 ? (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {s.cv_keywords_found.slice(0, 20).map(kw => (
                <span key={kw} style={{ background: '#f5f3ff', color: '#7c3aed', fontSize: 10, padding: '2px 7px', borderRadius: 20 }}>{kw}</span>
              ))}
              {s.cv_keywords_found.length > 20 && <span style={{ fontSize: 10, color: '#9ca3af' }}>+{s.cv_keywords_found.length - 20} daha</span>}
            </div>
          ) : (
            <div style={{ fontSize: 12, color: '#9ca3af' }}>{s.cv_keyword_score != null ? 'Eşleşen anahtar kelime bulunamadı.' : 'CV analizi henüz çalıştırılmadı. Üstteki "CV Analizi Çalıştır" butonunu kullanın.'}</div>
          )}
          {s.cv_analyzed_at && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 8 }}>Son analiz: {new Date(s.cv_analyzed_at).toLocaleString('tr-TR')}</div>}
        </div>

        {/* AI Özeti */}
        {s.llm_summary && (
          <div style={{ background: '#f5f3ff', border: '1px solid #e9d5ff', borderRadius: 10, padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#7c3aed' }}>✦ AI CV Analizi</div>
              {s.llm_level && (
                <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: '#ede9fe', color: '#7c3aed', fontWeight: 600 }}>
                  {{ junior: 'Junior', mid: 'Mid-Level', senior: 'Senior' }[s.llm_level] || s.llm_level}
                </span>
              )}
              {s.llm_analyzed_at && (
                <span style={{ fontSize: 10, color: '#a78bfa', marginLeft: 'auto' }}>
                  {new Date(s.llm_analyzed_at).toLocaleString('tr-TR')}
                </span>
              )}
            </div>
            <p style={{ fontSize: 12, color: '#4c1d95', lineHeight: 1.6, margin: '0 0 10px' }}>{s.llm_summary}</p>
            {s.llm_strengths?.length > 0 && (
              <div style={{ marginBottom: 6 }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: '#065f46', marginBottom: 4 }}>Güçlü Yanlar</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {s.llm_strengths.map((str, i) => (
                    <span key={i} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 20, background: '#d1fae5', color: '#065f46' }}>+ {str}</span>
                  ))}
                </div>
              </div>
            )}
            {s.llm_weaknesses?.length > 0 && (
              <div>
                <div style={{ fontSize: 11, fontWeight: 600, color: '#92400e', marginBottom: 4 }}>Gelişim Alanları</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {s.llm_weaknesses.map((w, i) => (
                    <span key={i} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 20, background: '#fef3c7', color: '#92400e' }}>△ {w}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        {!s.llm_summary && (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 14, textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: '#9ca3af' }}>✦ AI analizi henüz yapılmadı</div>
          </div>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 0' }}>
        {s.llm_summary && (
          <button onClick={() => handleDownloadPDF(s)}
            style={{ padding: '7px 16px', background: '#6d28d9', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
            📄 PDF Rapor İndir
          </button>
        )}
        <button onClick={() => { setAssignFor(s); setAssignPositionId(assignPositions[0]?.id || ''); setAssignMessage(''); }}
          style={{ padding: '7px 16px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
          Şirkete Ata
        </button>
      </div>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, padding: '12px 24px 20px' }}>

      {/* Sol kolon */}
      <div>
        {/* Kişisel */}
        <Section title="👤 Kişisel Bilgiler">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, fontSize: 13 }}>
            {[
              ['Telefon', s.phone], ['Şehir', s.city], ['Uyruk', s.nationality],
              ['Cinsiyet', s.gender],
              ['Doğum Tarihi', s.birth_date ? new Date(s.birth_date).toLocaleDateString('tr-TR') : null],
              ['Askerlik', s.military_status],
            ].map(([l, v]) => v ? (
              <div key={l}><span style={{ color: '#9ca3af' }}>{l}: </span><span style={{ color: '#374151' }}>{v}</span></div>
            ) : null)}
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
            {s.linkedin_url && <a href={s.linkedin_url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#2563eb' }}>🔗 LinkedIn</a>}
            {s.github_url && <a href={s.github_url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#2563eb' }}>🐙 GitHub</a>}
            {s.website_url && <a href={s.website_url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#2563eb' }}>🌐 Website</a>}
            {s.twitter_url && <a href={s.twitter_url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#2563eb' }}>🐦 Twitter</a>}
          </div>
        </Section>

        {/* Eğitim */}
        <Section title="🎓 Eğitim">
          <div style={{ fontSize: 13, color: '#374151', marginBottom: 6 }}>
            <div style={{ fontWeight: 600 }}>{s.university}</div>
            <div>{s.department}{s.grade ? ` • ${s.grade}. Sınıf` : ''}{s.gpa ? ` • GPA: ${s.gpa}` : ''}{s.graduation_year ? ` • Mezuniyet: ${s.graduation_year}` : ''}</div>
          </div>
          {(Array.isArray(s.education_detail) ? s.education_detail : []).map((e, i) => (
            <div key={i} style={{ padding: '6px 10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, marginBottom: 4, fontSize: 12 }}>
              <span style={{ fontWeight: 600 }}>{e.institution}</span> — {e.degree} / {e.field}
              {e.start_date && <span style={{ color: '#9ca3af' }}> • {e.start_date}{e.end_date ? ` → ${e.end_date}` : ' (devam)'}</span>}
            </div>
          ))}
        </Section>

        {/* Beceriler */}
        {(s.skills || []).length > 0 && (
          <Section title={`🛠️ Teknik Beceriler (${s.skills.length})`}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
              {s.skills.map(sk => {
                const level = (s.skill_levels || {})[sk];
                return (
                  <span key={sk} style={{ background: '#eff6ff', color: '#1d4ed8', fontSize: 11, padding: '2px 8px', borderRadius: 20 }}>
                    {sk}{level ? ` · ${level}` : ''}
                  </span>
                );
              })}
            </div>
          </Section>
        )}

        {/* Sertifikalar */}
        {(s.certificates || []).length > 0 && (
          <Section title={`🏆 Sertifikalar (${s.certificates.length})`}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
              {s.certificates.map(cert => {
                const detail = (Array.isArray(s.certificates_detail) ? s.certificates_detail : []).find(d => d.name === cert);
                return (
                  <span key={cert} style={{ background: '#ecfdf5', color: '#059669', fontSize: 11, padding: '2px 8px', borderRadius: 20 }}>
                    {cert}{detail?.status ? ` · ${detail.status}` : ''}{detail?.date ? ` (${detail.date})` : ''}
                  </span>
                );
              })}
            </div>
          </Section>
        )}

        {/* Diller */}
        {(Array.isArray(s.languages) ? s.languages : []).filter(l => l.language).length > 0 && (
          <Section title="🌍 Yabancı Dil">
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {s.languages.filter(l => l.language).map((l, i) => (
                <span key={i} style={{ background: '#f3f4f6', color: '#374151', fontSize: 12, padding: '3px 10px', borderRadius: 20 }}>
                  {l.language} — {l.level}{l.note ? ` (${l.note})` : ''}
                </span>
              ))}
            </div>
          </Section>
        )}
      </div>

      {/* Sağ kolon */}
      <div>
        {/* CTF */}
        {s.ctf_platforms && Object.keys(s.ctf_platforms).some(k => s.ctf_platforms[k]?.username) && (
          <Section title="🚩 CTF & Platform Profilleri">
            {Object.entries(s.ctf_platforms).filter(([, v]) => v?.username).map(([platform, data]) => (
              <div key={platform} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, marginBottom: 4, fontSize: 12 }}>
                <span style={{ fontWeight: 600, color: '#374151' }}>{platform}</span>
                <span style={{ color: '#6b7280' }}>{data.username}{data.rank ? ` • ${data.rank}` : ''}{data.points ? ` • ${data.points} puan` : ''}</span>
              </div>
            ))}
          </Section>
        )}

        {/* İş Deneyimi */}
        {(Array.isArray(s.work_experiences) ? s.work_experiences : []).length > 0 && (
          <Section title="💼 İş & Staj Deneyimi">
            {s.work_experiences.map((exp, i) => (
              <div key={i} style={{ padding: '8px 10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, marginBottom: 6, fontSize: 12 }}>
                <div style={{ fontWeight: 600, color: '#111827' }}>{exp.position} <span style={{ fontWeight: 400, color: '#6b7280' }}>@ {exp.company}</span></div>
                <div style={{ color: '#9ca3af', marginTop: 2 }}>{exp.type} • {exp.start_date}{exp.current ? ' → Devam' : exp.end_date ? ` → ${exp.end_date}` : ''}</div>
                {exp.description && <div style={{ color: '#374151', marginTop: 4 }}>{exp.description}</div>}
                {exp.technologies && <div style={{ color: '#6b7280', marginTop: 3 }}>🛠 {exp.technologies}</div>}
              </div>
            ))}
          </Section>
        )}

        {/* Projeler */}
        {(Array.isArray(s.projects) ? s.projects : []).length > 0 && (
          <Section title="💡 Projeler">
            {s.projects.map((p, i) => (
              <div key={i} style={{ padding: '8px 10px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, marginBottom: 6, fontSize: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: 600, color: '#111827' }}>{p.name}</span>
                  {p.type && <span style={{ fontSize: 10, background: '#eff6ff', color: '#1d4ed8', padding: '1px 6px', borderRadius: 20 }}>{p.type}</span>}
                </div>
                {p.description && <div style={{ color: '#374151', marginTop: 3 }}>{p.description}</div>}
                {p.technologies && <div style={{ color: '#6b7280', marginTop: 3 }}>🛠 {p.technologies}</div>}
                <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                  {p.github_url && <a href={p.github_url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: '#2563eb' }}>GitHub</a>}
                  {p.demo_url && <a href={p.demo_url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: '#2563eb' }}>Demo</a>}
                </div>
              </div>
            ))}
          </Section>
        )}

        {/* Ödüller */}
        {(Array.isArray(s.awards) ? s.awards : []).length > 0 && (
          <Section title="🥇 Ödüller & Başarılar">
            {s.awards.map((a, i) => (
              <div key={i} style={{ padding: '5px 10px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, marginBottom: 4, fontSize: 12 }}>
                <span style={{ fontWeight: 600 }}>{a.name}</span>
                {a.organizer && <span style={{ color: '#6b7280' }}> • {a.organizer}</span>}
                {a.rank && <span style={{ color: '#d97706' }}> • {a.rank}</span>}
                {a.date && <span style={{ color: '#9ca3af' }}> • {a.date}</span>}
              </div>
            ))}
          </Section>
        )}

        {/* Yayınlar */}
        {(Array.isArray(s.publications) ? s.publications : []).length > 0 && (
          <Section title="📝 Yayınlar & Yazılar">
            {s.publications.map((p, i) => (
              <div key={i} style={{ padding: '5px 10px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6, marginBottom: 4, fontSize: 12 }}>
                <a href={p.url} target="_blank" rel="noreferrer" style={{ fontWeight: 600, color: '#2563eb' }}>{p.title}</a>
                <span style={{ color: '#9ca3af' }}> • {p.type}{p.platform ? ` • ${p.platform}` : ''}{p.date ? ` • ${p.date}` : ''}</span>
              </div>
            ))}
          </Section>
        )}

        {/* Staj Tercihleri */}
        {s.internship_preferences && Object.keys(s.internship_preferences).length > 0 && (
          <Section title="⚙️ Staj Tercihleri">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, fontSize: 12 }}>
              {[
                ['Başlangıç', s.internship_preferences.start_date],
                ['Süre', s.internship_preferences.duration],
                ['Staj Türü', s.internship_preferences.internship_type],
                ['Çalışma Şekli', s.internship_preferences.work_type],
                ['Tercih Şehir', s.internship_preferences.preferred_city],
                ['Ücret Beklentisi', s.internship_preferences.salary_expectation ? `₺${s.internship_preferences.salary_expectation}` : null],
                ['Uygunluk', s.internship_preferences.availability],
              ].map(([l, v]) => v ? (
                <div key={l}><span style={{ color: '#9ca3af' }}>{l}: </span><span style={{ color: '#374151' }}>{v}</span></div>
              ) : null)}
              {(s.internship_preferences.internship_periods || []).length > 0 && (
                <div style={{ gridColumn: '1 / -1', marginTop: 4 }}>
                  <span style={{ color: '#9ca3af' }}>Staj Dönemi: </span>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 4 }}>
                    {s.internship_preferences.internship_periods.map(p => (
                      <span key={p} style={{ background: '#eff6ff', color: '#1d4ed8', fontSize: 11, padding: '2px 10px', borderRadius: 20, fontWeight: 500 }}>{p}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {s.internship_preferences.notes && <div style={{ marginTop: 6, fontSize: 12, color: '#374151', padding: 8, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6 }}>{s.internship_preferences.notes}</div>}
          </Section>
        )}

        {/* Hakkımda */}
        {(s.bio || s.about_me) && (
          <Section title="📄 Hakkımda">
            {s.bio && <div style={{ fontSize: 13, fontWeight: 500, color: '#111827', marginBottom: 6 }}>{s.bio}</div>}
            {s.about_me && <div style={{ fontSize: 12, color: '#374151', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{s.about_me}</div>}
          </Section>
        )}

        {/* CV */}
        {s.cv_file_url && (
          <Section title="📎 CV">
            <button onClick={() => handleViewCV(s.cv_file_url)}
              style={{ fontSize: 13, color: '#16a34a', fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>📄 CV Görüntüle</button>
          </Section>
        )}
      </div>
    </div>
    </div>
    );
  };

  return (
    <>
    <div style={{ maxWidth: 1100 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827' }}>Öğrenciler</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={handleRunCV} disabled={runningCV} style={{ padding: '8px 18px', background: runningCV ? '#93c5fd' : '#7c3aed', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            {runningCV ? '⏳ Çalışıyor...' : '🤖 CV Analizi Çalıştır'}
          </button>
          <button onClick={handleRunLLM} disabled={runningLLM} style={{ padding: '8px 18px', background: runningLLM ? '#a78bfa' : '#6d28d9', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            {runningLLM ? '⏳ Çalışıyor...' : '✦ AI Analizi Çalıştır'}
          </button>
          <button onClick={handleExport} style={{ padding: '8px 18px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            📥 Excel İndir
          </button>
        </div>
      </div>

      {/* Filtreler */}
      <form onSubmit={handleSearch} style={{ marginBottom: 20, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 14 }}>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <input placeholder="Ad / Soyad" value={search.name} onChange={e => setSearch(s => ({ ...s, name: e.target.value }))} style={{ flex: '1 1 160px', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
          <input placeholder="E-posta" value={search.email} onChange={e => setSearch(s => ({ ...s, email: e.target.value }))} style={{ flex: '1 1 160px', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
          <input placeholder="Üniversite" value={search.university} onChange={e => setSearch(s => ({ ...s, university: e.target.value }))} style={{ flex: '1 1 160px', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
          <input placeholder="Bölüm" value={search.department} onChange={e => setSearch(s => ({ ...s, department: e.target.value }))} style={{ flex: '1 1 160px', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
        </div>
        {showAdvanced && (
          <div style={{ marginTop: 10, padding: 12, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 10 }}>Detaylı Arama</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10 }}>
              <input placeholder="Şehir" value={search.city} onChange={e => setSearch(s => ({ ...s, city: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
              <select value={search.grade} onChange={e => setSearch(s => ({ ...s, grade: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">Sınıf (tümü)</option>
                <option value="1">1. Sınıf</option><option value="2">2. Sınıf</option>
                <option value="3">3. Sınıf</option><option value="4">4. Sınıf</option>
              </select>
              <input placeholder="Min GPA (örn: 2.5)" type="number" step="0.1" min="0" max="4" value={search.gpa_min} onChange={e => setSearch(s => ({ ...s, gpa_min: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
              <input placeholder="Beceri (örn: Python)" value={search.skill} onChange={e => setSearch(s => ({ ...s, skill: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
              <input placeholder="Sertifika (örn: OSCP)" value={search.certificate} onChange={e => setSearch(s => ({ ...s, certificate: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
              <select value={search.work_type} onChange={e => setSearch(s => ({ ...s, work_type: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">Çalışma Şekli (tümü)</option>
                <option value="Uzaktan">Uzaktan</option>
                <option value="Hibrit">Hibrit</option>
                <option value="Ofiste">Ofiste</option>
              </select>
              <select value={search.profile_complete} onChange={e => setSearch(s => ({ ...s, profile_complete: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">Profil (tümü)</option>
                <option value="true">Tamamlanmış</option>
                <option value="false">Eksik</option>
              </select>
              <select value={search.has_cv} onChange={e => setSearch(s => ({ ...s, has_cv: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">CV (tümü)</option>
                <option value="true">CV var</option>
                <option value="false">CV yok</option>
              </select>
              <select value={search.internship_type} onChange={e => setSearch(s => ({ ...s, internship_type: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">Staj Türü (tümü)</option>
                <option value="Gönüllü">Gönüllü</option>
                <option value="Zorunlu">Zorunlu</option>
                <option value="Her ikisi de olur">Her ikisi de olur</option>
              </select>
              <select value={search.internship_period} onChange={e => setSearch(s => ({ ...s, internship_period: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">Staj Dönemi (tümü)</option>
                <option value="Uzun Dönem">Uzun Dönem</option>
                <option value="Haziran">Haziran</option>
                <option value="Temmuz">Temmuz</option>
                <option value="Ağustos">Ağustos</option>
                <option value="Eylül">Eylül</option>
              </select>
              <select value={search.llm_level} onChange={e => setSearch(s => ({ ...s, llm_level: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">AI Seviye (tümü)</option>
                <option value="junior">Junior</option>
                <option value="mid">Mid-Level</option>
                <option value="senior">Senior</option>
              </select>
              <input placeholder="Ödül / Başarı (örn: HackTheBox)" value={search.award} onChange={e => setSearch(s => ({ ...s, award: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
              <input placeholder="Proje (ad veya teknoloji)" value={search.project} onChange={e => setSearch(s => ({ ...s, project: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }} />
              <select value={search.focus_area} onChange={e => setSearch(s => ({ ...s, focus_area: e.target.value }))} style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                <option value="">Uzmanlık Alanı (tümü)</option>
                {['Penetration Testing','Web Uygulama Güvenliği','Ağ Güvenliği','Kablosuz Ağ Güvenliği','Zararlı Yazılım Analizi','Dijital Adli Bilişim (DFIR)','Olay Müdahalesi (IR)','Güvenlik Operasyonları (SOC)','Tehdit Avcılığı (Threat Hunting)','Tehdit İstihbaratı (CTI)','Bulut Güvenliği','Konteyner Güvenliği','Mobil Uygulama Güvenliği','IoT Güvenliği','ICS/SCADA Güvenliği','Kriptografi','Tersine Mühendislik','Exploit Geliştirme','Bug Bounty','CTF','Red Team','Blue Team','Purple Team','GRC (Governance, Risk, Compliance)','ISO 27001','KVKK/GDPR'].map(a => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </select>
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, marginTop: 10, justifyContent: 'space-between' }}>
          <button type="button" onClick={() => setShowAdvanced(v => !v)} style={{ padding: '8px 14px', background: 'transparent', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            {showAdvanced ? '▲ Detaylı Aramayı Gizle' : '▼ Detaylı Arama'}
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" onClick={() => { setSearch({ department: '', university: '', name: '', email: '', city: '', grade: '', gpa_min: '', skill: '', certificate: '', profile_complete: '', has_cv: '', work_type: '', internship_type: '', internship_period: '', award: '', project: '', focus_area: '', llm_level: '' }); load(); }} style={{ padding: '8px 14px', background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Temizle</button>
            <button type="submit" style={{ padding: '8px 18px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>🔍 Filtrele</button>
          </div>
        </div>
      </form>

      {/* Tablo */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflowX: 'auto' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Yükleniyor...</div>
        ) : students.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Öğrenci bulunamadı.</div>
        ) : (
          <table style={{ width: '100%', minWidth: 1100, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                <th style={{ width: 28, padding: '10px 8px' }}></th>
                <SortTh field="name">Ad Soyad</SortTh>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#6b7280', whiteSpace: 'nowrap' }}>E-posta</th>
                <SortTh field="university">Üniversite / Bölüm</SortTh>
                <SortTh field="grade">Sınıf / GPA</SortTh>
                <SortTh field="city">Şehir</SortTh>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#6b7280', whiteSpace: 'nowrap' }}>Beceri</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#6b7280', whiteSpace: 'nowrap' }}>Sertifika</th>
                <SortTh field="internship_type">Staj Türü</SortTh>
                <SortTh field="profile_score">Profil Puanı</SortTh>
                <SortTh field="cv_score">CV Puanı</SortTh>
                <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#6b7280', whiteSpace: 'nowrap' }}>Durum</th>
                <SortTh field="applications">Başvuru</SortTh>
              </tr>
            </thead>
            <tbody>
              {students.map(st => {
                const isExpanded = expanded === st.id;
                const det = details[st.id];
                const isLoading = detailLoading === st.id;
                return (
                  <React.Fragment key={st.id}>
                    <tr
                      onClick={() => toggleRow(st)}
                      style={{ borderBottom: isExpanded ? 'none' : '1px solid #f3f4f6', cursor: 'pointer', background: isExpanded ? '#f0f7ff' : '', transition: 'background 0.1s' }}
                      onMouseEnter={e => { if (!isExpanded) e.currentTarget.style.background = '#f9fafb'; }}
                      onMouseLeave={e => { if (!isExpanded) e.currentTarget.style.background = ''; }}
                    >
                      <td style={{ padding: '12px 8px', textAlign: 'center', color: '#9ca3af', fontSize: 12 }}>
                        {isExpanded ? '▲' : '▶'}
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: 14, fontWeight: 500, color: '#111827' }}>
                        {st.first_name || st.last_name ? `${st.first_name} ${st.last_name}`.trim() : <span style={{ color: '#9ca3af' }}>—</span>}
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: 13, color: '#6b7280', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{st.email}</td>
                      <td style={{ padding: '12px 14px', fontSize: 13, maxWidth: 200 }}>
                        <div style={{ color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{st.university || '—'}</div>
                        <div style={{ color: '#9ca3af', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{st.department}</div>
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: 13, color: '#374151' }}>
                        <div>{st.grade ? `${st.grade}. Sınıf` : '—'}</div>
                        <div style={{ color: '#9ca3af', fontSize: 12 }}>{st.gpa ? `GPA: ${st.gpa}` : ''}</div>
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: 13, color: '#6b7280' }}>{st.city || '—'}</td>
                      <td style={{ padding: '12px 14px' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                          {(st.skills || []).slice(0, 2).map(sk => <Tag key={sk} label={sk} />)}
                          {(st.skills || []).length > 2 && <Tag label={`+${st.skills.length - 2}`} color="#6b7280" bg="#f3f4f6" />}
                          {!st.skills?.length && <span style={{ color: '#9ca3af', fontSize: 12 }}>—</span>}
                        </div>
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: 13, color: '#374151', textAlign: 'center' }}>
                        {(st.certificates || []).length || '—'}
                      </td>
                      <td style={{ padding: '12px 14px' }}>
                        {st.pref_internship_type ? (
                          <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 20, fontWeight: 500,
                            background: st.pref_internship_type === 'Zorunlu' ? '#eff6ff' : st.pref_internship_type === 'Gönüllü' ? '#f0fdf4' : '#f3f4f6',
                            color: st.pref_internship_type === 'Zorunlu' ? '#1d4ed8' : st.pref_internship_type === 'Gönüllü' ? '#16a34a' : '#6b7280' }}>
                            {st.pref_internship_type}
                          </span>
                        ) : <span style={{ color: '#d1d5db', fontSize: 12 }}>—</span>}
                      </td>
                      <td style={{ padding: '12px 14px' }}>
                        {(() => {
                          const total = (+(st.skills_score||0)) + (+(st.cert_score||0)) + (+(st.academic_score||0)) + (+(st.ctf_score||0)) + (+(st.experience_score||0));
                          const color = total >= 70 ? '#059669' : total >= 40 ? '#d97706' : '#6b7280';
                          return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <div style={{ width: 36, height: 36, borderRadius: '50%', border: `3px solid ${color}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color }}>{total}</div>
                            </div>
                          );
                        })()}
                      </td>
                      <td style={{ padding: '12px 14px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}>
                          {st.cv_keyword_score != null ? (
                            <div style={{ width: 36, height: 36, borderRadius: '50%', border: `3px solid ${st.cv_keyword_score >= 70 ? '#7c3aed' : st.cv_keyword_score >= 40 ? '#0891b2' : '#6b7280'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: st.cv_keyword_score >= 70 ? '#7c3aed' : st.cv_keyword_score >= 40 ? '#0891b2' : '#6b7280' }}>{st.cv_keyword_score}</div>
                          ) : <span style={{ color: '#d1d5db', fontSize: 12 }}>—</span>}
                          {st.llm_level && (
                            <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 20, fontWeight: 600,
                              background: { junior: '#f3f4f6', mid: '#eff6ff', senior: '#ede9fe' }[st.llm_level] || '#f3f4f6',
                              color: { junior: '#6b7280', mid: '#2563eb', senior: '#7c3aed' }[st.llm_level] || '#6b7280' }}>
                              {{ junior: 'Junior', mid: 'Mid', senior: 'Senior' }[st.llm_level] || st.llm_level}
                            </span>
                          )}
                        </div>
                      </td>
                      <td style={{ padding: '12px 14px' }}>
                        <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 20, fontWeight: 500, background: st.profile_complete ? '#f0fdf4' : '#fef9c3', color: st.profile_complete ? '#16a34a' : '#ca8a04' }}>
                          {st.profile_complete ? 'Tamamlandı' : 'Eksik'}
                        </span>
                      </td>
                      <td style={{ padding: '12px 14px', fontSize: 13, color: '#6b7280', textAlign: 'center' }}>{st.application_count}</td>
                    </tr>
                    {isExpanded && (
                      <tr>
                        <td colSpan={13} style={{ padding: 0, borderBottom: '2px solid #bfdbfe' }}>
                          {isLoading ? (
                            <div style={{ padding: 24, textAlign: 'center', color: '#9ca3af', background: '#f8fafc' }}>Yükleniyor...</div>
                          ) : det ? (
                            <DetailPanel s={det} />
                          ) : null}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div style={{ marginTop: 12, fontSize: 12, color: '#9ca3af' }}>Toplam {students.length} öğrenci • Detay için satıra tıklayın</div>
      {assignToast && (
        <div style={{ position:'fixed', top:24, right:24, zIndex:9999, background:'#16a34a', color:'#fff', padding:'10px 18px', borderRadius:10, fontSize:14, fontWeight:500, boxShadow:'0 4px 16px rgba(0,0,0,0.15)' }}>{assignToast}</div>
      )}
      {cvToast && (
        <div style={{ position:'fixed', top:64, right:24, zIndex:9999, background:'#7c3aed', color:'#fff', padding:'10px 18px', borderRadius:10, fontSize:14, fontWeight:500, boxShadow:'0 4px 16px rgba(0,0,0,0.15)' }}>{cvToast}</div>
      )}
      {assignFor && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:24, width:'100%', maxWidth:480 }}>
            <h2 style={{ fontSize:17, fontWeight:700, marginBottom:4 }}>Öğrenciyi Şirkete Ata</h2>
            <p style={{ fontSize:13, color:'#6b7280', marginBottom:16 }}>{assignFor.first_name} {assignFor.last_name} bir şirket ilanına davet edilecek.</p>
            <label style={{ display:'block', fontSize:13, fontWeight:500, color:'#374151', marginBottom:6 }}>İlan *</label>
            <select value={assignPositionId} onChange={e => setAssignPositionId(e.target.value)} style={{ width:'100%', padding:'9px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, marginBottom:12 }}>
              <option value="">— Seçin —</option>
              {assignPositions.map(p => <option key={p.id} value={p.id}>{p.company_name} — {p.title}</option>)}
            </select>
            <label style={{ display:'block', fontSize:13, fontWeight:500, color:'#374151', marginBottom:6 }}>Mesaj (opsiyonel)</label>
            <textarea rows={3} value={assignMessage} onChange={e => setAssignMessage(e.target.value)} placeholder="Öğrenciye iletilecek not" style={{ width:'100%', padding:'9px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, resize:'vertical', boxSizing:'border-box' }} />
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
              <button onClick={() => setAssignFor(null)} style={{ padding:'9px 16px', background:'#f3f4f6', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, cursor:'pointer' }}>İptal</button>
              <button disabled={!assignPositionId || assignSending} onClick={async () => {
                setAssignSending(true);
                try {
                  await extendedAdminAPI.assignStudent({ student_id: assignFor.id, position_id: assignPositionId, message: assignMessage });
                  setAssignToast('Öğrenci ilana davet edildi');
                  setTimeout(() => setAssignToast(''), 3500);
                  setAssignFor(null);
                } catch (e) { alert(e.response?.data?.error || 'Atama yapılamadı'); }
                setAssignSending(false);
              }} style={{ padding:'9px 20px', background: (!assignPositionId || assignSending) ? '#93c5fd' : '#2563eb', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:500, cursor:'pointer' }}>
                {assignSending ? 'Gönderiliyor...' : 'Daveti Gönder'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    <Pagination />
  </>
  );
};


export default AdminStudents;
